module.exports = __webpack_public_path__ + "static/media/right-arrow.7384017c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/right-arrow.svg
// module id = 1747
// module chunks = 0